angular.module('bmsApp.reports', ['ui.router'])
	.config([
		'$stateProvider',
		'$urlRouterProvider',
		function config($stateProvider,
						$urlRouterProvider) {

			$stateProvider

				.state('main.reports', {
					url: '/reports',
					abstract: true
				})

				.state('main.reports.index', {
					url: '/list',
					views: {
						'main@main': {
							templateUrl: 'ng/reports/templates/ReportIndex.html',
							controller: 'ReportIndexCtrl as ReportIndex'
						}
					},
					ncyBreadcrumb: {label: 'Reports'}
				})

				.state('main.reports.planning', {
					url: '/planning',
					views: {
						'main@main': {
							templateUrl: 'ng/reports/templates/ReportPlanning.html',
							controller: 'ReportPlanningCtrl as ReportPlanning'
						}
					},
					ncyBreadcrumb: {
						label: 'Planning Reports'
					}
				})

			;

		}
	]);
